
<template>
  <div class="content">
    <!-- search bar -->
    <div class="row my-3 justify-content-end">
      <div class="col-8"></div>
       <div class="col-auto">
        <!-- Header Search Input -->
        <a-input-search class="header-search" :class="searchLoading ? 'loading' : ''" placeholder="Search by BusinessUnit#, Location#, Operator#, City, State, FirstName, LastName…"
          @search="onSearch" :loading='searchLoading' v-model="searchQuery">
          <svg slot="prefix" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.29583 13.5892 10.4957 12.8907 11.4765L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L11.4765 12.8907C10.4957 13.5892 9.29583 14 8 14C4.68629 14 2 11.3137 2 8Z"
              fill="#111827" />
          </svg>
        </a-input-search>
        <!-- / Header Search Input -->
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header">
            <div class="row justify-content-between align-items-between mx-3">

              <h5 class="card-title">Fields</h5>
              
              <div>
                  <base-button class="btn btn-primary" @click="modalFields = true">Add</base-button>
	              <base-button class="btn btn-primary" @click="toggleView">Toggle View</base-button>
              </div>
              
              <modal :show.sync="modalFields">
                <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel">Add Field</h5>
                </template>
                <div>
                  <form @submit.prevent>
                  </form>
                </div>
                <template slot="footer">
                  <base-button type="primary" @click="handleAddSubmitted()">Save</base-button>
                </template>
              </modal>
            </div>
          </template>


          <!-- Conditionally render the view based on the 'isTableView' flag -->
          <div v-if="isTableView">
            <!-- Render the existing Table View -->
            <a-table :columns="columns" :data-source="fields" :row-key="record => record.FieldId" :pagination="pagination"
              :loading="searchLoading" @change="onTableChange" :scroll="{ x: 'max-content' }">

              <template slot="fieldId" slot-scope="dataIndex">
              	<router-link  :to="`/field/${dataIndex}`"><a >{{ dataIndex }}</a></router-link>
              </template>

	<template slot="isLinkField" slot-scope="dataIndex">
       {{ dataIndex ? 'Yes' : 'No' }}
   </template>
	<template slot="isAddField" slot-scope="dataIndex">
       {{ dataIndex ? 'Yes' : 'No' }}
   </template>
	<template slot="isSearchField" slot-scope="dataIndex">
       {{ dataIndex ? 'Yes' : 'No' }}
   </template>
	<template slot="isUpdatable" slot-scope="dataIndex">
       {{ dataIndex ? 'Yes' : 'No' }}
   </template>
	<template slot="isDefaultVisible" slot-scope="dataIndex">
       {{ dataIndex ? 'Yes' : 'No' }}
   </template>
	<template slot="isDetailViewVisible" slot-scope="dataIndex">
       {{ dataIndex ? 'Yes' : 'No' }}
   </template>
	<template slot="isDetailViewInput" slot-scope="dataIndex">
       {{ dataIndex ? 'Yes' : 'No' }}
   </template>
	<template slot="isAutoSuggest" slot-scope="dataIndex">
       {{ dataIndex ? 'Yes' : 'No' }}
   </template>

             <template slot="lastModified" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="createdOn" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="blackOutStartDate" slot-scope="dataIndex">
              	{{ formatDate(dataIndex) }}
              </template>
            </a-table>
          </div>
          <div v-else>
            <!-- Render the Picture View  -->
            <FieldPictureView :fields="fields" />
          </div>

        </card>
      </div>
    </div>

  </div>
</template>

<script>
import Modal from "@/components/Modal";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import { Card } from "@/components/Card";
import FieldService from "../services/FieldService";
import { ASelect, ASelectOption, AButton, Table, Pagination } from "ant-design-vue";
import FieldPictureView from './FieldPictureView.vue';


const fieldsColumns = [
  "fieldId",
  "year",
  "date",
  "competitionId",
  "fieldId"
]

export default {
  props: {
    fields: {
      type: Array,
      required: true,
    },
    totalElements: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
  },
  components: {
    Card,
    Modal,
    BaseButton,
    BaseInput,
    Table,

    Pagination,
    FieldPictureView
  },

  data() {
    return {
      modalFields: false,
        isTableView: true,

      columns: [
        {
          title: 'Field Id',
				dataIndex: 'fieldId',
	          visible: true,
          scopedSlots: { customRender: 'fieldId' },
          sorter: true
          //sorter: (a, b) => a.fieldId - b.fieldId,
          //sorter: (a, b) => a.fieldId.localeCompare(b.fieldId),
        },
        {
          title: 'Name Id',
		dataIndex: 'nameId',
          visible: false,
          scopedSlots: { customRender: 'nameId' },
          sorter: true
          //sorter: (a, b) => a.nameId - b.nameId,
          //sorter: (a, b) => a.nameId.localeCompare(b.nameId),
        },
        {
          title: 'Field Name',
		dataIndex: 'fieldName',
          visible: true,
          scopedSlots: { customRender: 'fieldName' },
          sorter: true
          //sorter: (a, b) => a.fieldName - b.fieldName,
          //sorter: (a, b) => a.fieldName.localeCompare(b.fieldName),
        },
        {
          title: 'Domain Class Id',
		dataIndex: 'domainClassId',
          visible: false,
          scopedSlots: { customRender: 'domainClassId' },
          sorter: true
          //sorter: (a, b) => a.domainClassId - b.domainClassId,
          //sorter: (a, b) => a.domainClassId.localeCompare(b.domainClassId),
        },
        {
          title: 'Domain Class Name',
		dataIndex: 'domainClassName',
          visible: true,
          scopedSlots: { customRender: 'domainClassName' },
          sorter: true
          //sorter: (a, b) => a.domainClassName - b.domainClassName,
          //sorter: (a, b) => a.domainClassName.localeCompare(b.domainClassName),
        },
        {
          title: 'Field Type Id ',
		dataIndex: 'fieldTypeId',
          visible: false,
          scopedSlots: { customRender: 'fieldTypeId' },
          sorter: true
          //sorter: (a, b) => a.fieldTypeId - b.fieldTypeId,
          //sorter: (a, b) => a.fieldTypeId.localeCompare(b.fieldTypeId),
        },
        {
          title: 'Field Type',
		dataIndex: 'fieldType',
          visible: true,
          scopedSlots: { customRender: 'fieldType' },
          sorter: true
          //sorter: (a, b) => a.fieldType - b.fieldType,
          //sorter: (a, b) => a.fieldType.localeCompare(b.fieldType),
        },
        {
          title: 'Is Link Field ',
		dataIndex: 'isLinkField',
          visible: true,
          scopedSlots: { customRender: 'isLinkField' },
          sorter: true
          //sorter: (a, b) => a.isLinkField - b.isLinkField,
          //sorter: (a, b) => a.isLinkField.localeCompare(b.isLinkField),
        },
        {
          title: 'Class Link Id ',
		dataIndex: 'classLinkId',
          visible: false,
          scopedSlots: { customRender: 'classLinkId' },
          sorter: true
          //sorter: (a, b) => a.classLinkId - b.classLinkId,
          //sorter: (a, b) => a.classLinkId.localeCompare(b.classLinkId),
        },
        {
          title: 'Class Link Field Name Id ',
		dataIndex: 'classLinkFieldNameId',
          visible: false,
          scopedSlots: { customRender: 'classLinkFieldNameId' },
          sorter: true
          //sorter: (a, b) => a.classLinkFieldNameId - b.classLinkFieldNameId,
          //sorter: (a, b) => a.classLinkFieldNameId.localeCompare(b.classLinkFieldNameId),
        },
        {
          title: 'Is Add Field ',
		dataIndex: 'isAddField',
          visible: true,
          scopedSlots: { customRender: 'isAddField' },
          sorter: true
          //sorter: (a, b) => a.isAddField - b.isAddField,
          //sorter: (a, b) => a.isAddField.localeCompare(b.isAddField),
        },
        {
          title: 'Is Search Field ',
		dataIndex: 'isSearchField',
          visible: true,
          scopedSlots: { customRender: 'isSearchField' },
          sorter: true
          //sorter: (a, b) => a.isSearchField - b.isSearchField,
          //sorter: (a, b) => a.isSearchField.localeCompare(b.isSearchField),
        },
        {
          title: 'Is Updatable ',
		dataIndex: 'isUpdatable',
          visible: true,
          scopedSlots: { customRender: 'isUpdatable' },
          sorter: true
          //sorter: (a, b) => a.isUpdatable - b.isUpdatable,
          //sorter: (a, b) => a.isUpdatable.localeCompare(b.isUpdatable),
        },
        {
          title: 'Is Default Visible ',
		dataIndex: 'isDefaultVisible',
          visible: true,
          scopedSlots: { customRender: 'isDefaultVisible' },
          sorter: true
          //sorter: (a, b) => a.isDefaultVisible - b.isDefaultVisible,
          //sorter: (a, b) => a.isDefaultVisible.localeCompare(b.isDefaultVisible),
        },
        {
          title: 'Is Detail View Visible ',
		dataIndex: 'isDetailViewVisible',
          visible: true,
          scopedSlots: { customRender: 'isDetailViewVisible' },
          sorter: true
          //sorter: (a, b) => a.isDetailViewVisible - b.isDetailViewVisible,
          //sorter: (a, b) => a.isDetailViewVisible.localeCompare(b.isDetailViewVisible),
        },
        {
          title: 'Is Detail View Input ',
		dataIndex: 'isDetailViewInput',
          visible: true,
          scopedSlots: { customRender: 'isDetailViewInput' },
          sorter: true
          //sorter: (a, b) => a.isDetailViewInput - b.isDetailViewInput,
          //sorter: (a, b) => a.isDetailViewInput.localeCompare(b.isDetailViewInput),
        },
        {
          title: 'Is Auto Suggest ',
		dataIndex: 'isAutoSuggest',
          visible: true,
          scopedSlots: { customRender: 'isAutoSuggest' },
          sorter: true
          //sorter: (a, b) => a.isAutoSuggest - b.isAutoSuggest,
          //sorter: (a, b) => a.isAutoSuggest.localeCompare(b.isAutoSuggest),
        },
        {
          title: 'Auto Suggest Domain Class Id ',
		dataIndex: 'autoSuggestDomainClassId',
          visible: false,
          scopedSlots: { customRender: 'autoSuggestDomainClassId' },
          sorter: true
          //sorter: (a, b) => a.autoSuggestDomainClassId - b.autoSuggestDomainClassId,
          //sorter: (a, b) => a.autoSuggestDomainClassId.localeCompare(b.autoSuggestDomainClassId),
        },
        {
          title: 'Auto Suggest Set Field Name Id ',
		dataIndex: 'autoSuggestSetFieldNameId',
          visible: false,
          scopedSlots: { customRender: 'autoSuggestSetFieldNameId' },
          sorter: true
          //sorter: (a, b) => a.autoSuggestSetFieldNameId - b.autoSuggestSetFieldNameId,
          //sorter: (a, b) => a.autoSuggestSetFieldNameId.localeCompare(b.autoSuggestSetFieldNameId),
        },
      ],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `Total ${total} fields`,
      },

      fields: [],
      fieldToAdd: {},

      fieldsTable: {
        columns: [...fieldsColumns],
        data: [],
      },

      // New properties for sorting and searching
      sortBy: 'fieldId',           // Column to sort by
      sortOrder: 'asc',     // Sort order (asc or desc)
      searchQuery: '',      // Search query
      searchLoading: false, // Initialize searchLoading property


    };
  },
  watch: {
    searchQuery: {
      handler: "handleSearchQueryChanged", // Call the fetchData method when searchQuery changes
      immediate: true, // Trigger immediately when the component is mounted
    },
  },

  methods: {

    async renderFieldsTable() {
      this.searchLoading = true; // Set searchLoading to true while fetching data
      this.searchLoading = false;

      this.pagination.total = this.totalElements;
      this.pagination.current = this.page;

      let fieldsTableData = [];
      for (let i = 0; i < this.fields.length; i++) {
        fieldsTableData.push({
          id: i,
          fieldId: this.fields[i].fieldId,
          year: this.fields[i].year,
          date: this.fields[i].date,
          competitionId: this.fields[i].competitionId,
          fieldId: this.fields[i].fieldId,
        });

      }
      this.searchLoading = false;
    },

    async onTableChange(pagination, filters, sorter) {
      if (sorter && sorter.field && sorter.order) {
        this.sortBy = sorter.field;
        if (sorter.order == "ascend") {
            this.sortOrder = "asc";
        } else {
            this.sortOrder = "desc";
        }
      }
      if (pagination) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
      }

	  this.$emit('get-all-fields',this.sortBy,this.sortOrder,this.pagination.current-1,this.pagination.pageSize);
      this.handleTableChanged()
    },
	
	initializeColumns() {
        this.columns = this.columns.filter(item => item.visible);
    },

    routingToApplicationDetail(id) {
      this.$router.push({ name: 'ApplicationDetail', params: { applicationId: id.toString() }})
    },
    routingToDomainClassDetail(id) {
      this.$router.push({ name: 'DomainClassDetail', params: { domainClassId: id.toString() }})
    },
    routingToFieldDetail(id) {
      this.$router.push({ name: 'FieldDetail', params: { fieldId: id.toString() }})
    },
    routingToDetailViewTableDetail(id) {
      this.$router.push({ name: 'DetailViewTableDetail', params: { detailViewTableId: id.toString() }})
    },
    routingToMappedClassDetail(id) {
      this.$router.push({ name: 'MappedClassDetail', params: { mappedClassId: id.toString() }})
    },
    routingToNameDetail(id) {
      this.$router.push({ name: 'NameDetail', params: { nameId: id.toString() }})
    },
    routingToSubmenuDetail(id) {
      this.$router.push({ name: 'SubmenuDetail', params: { submenuId: id.toString() }})
    },
    routingToFieldTypeDetail(id) {
      this.$router.push({ name: 'FieldTypeDetail', params: { fieldTypeId: id.toString() }})
    },
    routingToUserDetail(id) {
      this.$router.push({ name: 'UserDetail', params: { userId: id.toString() }})
    },
    routingToRoleDetail(id) {
      this.$router.push({ name: 'RoleDetail', params: { roleId: id.toString() }})
    },
    routingToUserRoleDetail(id) {
      this.$router.push({ name: 'UserRoleDetail', params: { userRoleId: id.toString() }})
    },
    
    handleSearchQueryChanged() {
    	console.log("handleSearchQueryChanged CALLED FROM @search")
    	this.$root.$emit('searchQueryForFieldsChanged', this.searchQuery);
		//this.renderFieldsTable();
    },

    onSearch(value) {
      console.log(value);
      this.searchQuery = value; // Update searchQuery when the user types
    },

    toggleView() {
      this.isTableView = !this.isTableView;
    },
	
	async handleAddSubmitted() {
      this.modalFields = false;

      const currentDate = new Date().getTime();
      this.fieldToAdd.created = currentDate;

      const jsonData = JSON.stringify(this.fieldToAdd);
      console.log(jsonData);
      
      const res = await FieldService.addField(jsonData);

      if (res.status === 200) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          type: "success",
          timeout: 3000,
        });
      }
	},
	
	handleTableChanged() {
	},
	
	formatTime(dateString) {
      if(dateString !== null){
        const date = new Date(dateString);
      return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')} EST`;
      }
      // Format the date here as needed, for example:
    },  
    
 formatDate(dateString) {
    if (dateString !== null) {
	    const date = new Date(dateString);
	    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    const day = String(date.getDate()).padStart(2, '0');
	    const monthAbbreviation = months[date.getMonth()];
	    const year = date.getFullYear();
	    return `${day} ${monthAbbreviation} ${year}`;
  	}
  	// Handle the case when dateString is null or invalid
  	return '';
    
   },

  },
  mounted() {
  	this.initializeColumns();
    this.renderFieldsTable();
  }
};
</script>

<style>
.modal-dialog {
  margin-top: -300px;
}
.ant-table-row  {
	text-align: center;
}
.ant-table-thead th span {
	text-align: center;
	width: 100%
}
.ant-table-fixed td span {
    text-align: center;
}
.header-search {
  width: 300px !important;
  margin-left: auto !important;
}
</style>
